import { State } from '@hookstate/core';
import { initialGlobalStateValues } from './InitialGlobalStateValues';
import { AppStoreType, QuestionState, ProductState, GlobalStateType } from './GlobalState';
import ResetMarkersAccess from './ResetMarkers';

const resetMarkers = ResetMarkersAccess();

const transform = (s: State<GlobalStateType>) => {
  const state = s;
  return {
    get appStore() {
      return state.nested('AppStore').get();
    },
    get question() {
      return state.nested('Question').get();
    },
    get product() {
      return state.nested('Product').get();
    },
    dispatchAppStore(key: keyof AppStoreType, value: any) {
      state.AppStore.merge({ [key]: value });
    },
    dispatchQuestion: (key: keyof QuestionState, value: any) => {
      state.Question.merge({ [key]: value });
    },
    dispatchProduct: (key: keyof ProductState, value: any) => {
      state.Product.merge({ [key]: value });
    },
    resetAppStore: () => {
      if (!resetMarkers.appStore) {
        resetMarkers.mark('appStore');
        state.AppStore.set(initialGlobalStateValues.AppStore);
      }
    },
    resetQuestion() {
      if (!resetMarkers.question) {
        resetMarkers.mark('question');
        state.Question.set(initialGlobalStateValues.Question);
      }
    },
    resetProduct: () => {
      if (!resetMarkers.product) {
        resetMarkers.mark('product');
        state.Product.set(initialGlobalStateValues.Product);
      }
    },
    reset: () => {
      state.set(initialGlobalStateValues);
    },
  };
};

export default transform;
